// @flow strict

import * as React from 'react';
import queryString from 'query-string';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

import { apiUrl } from '../../core/api/apiConfig';
import type { UpflowyUserData } from './types';
import { getUpflowyDataStorage } from './helpers';
import UpflowyOnboarding from './UpflowyOnboarding';

type PropsType = {|
  recaptchaSiteKey: string,
  upflowyUrl: string,
|};

const initialUserData: UpflowyUserData = {
  userEmail: '',
  customerId: '',
  signupUserId: '',
  origin: '',
};

const FreeTrialOnboarding = ({ recaptchaSiteKey, upflowyUrl }: PropsType) => {
  const [userData, setUserData] = React.useState<UpflowyUserData>(initialUserData);

  React.useEffect(() => {
    const { search, origin } = window.location;
    const parsed = queryString.parse(search);

    try {
      const storeId = atob(parsed.id);
      const { customerId, userEmail, signupUserId } = getUpflowyDataStorage(storeId);

      if (typeof signupUserId === 'undefined' || typeof userEmail === 'undefined') {
        window.location.href = new URL(apiUrl.kenticoFreeTrial);
        return;
      }

      setUserData({
        userEmail,
        customerId,
        signupUserId,
        origin,
      });
    } catch {
      window.location.href = new URL(apiUrl.kenticoFreeTrial);
    }
  }, []);

  return (
    <GoogleReCaptchaProvider reCaptchaKey={recaptchaSiteKey} useRecaptchaNet>
      {userData.signupUserId && <UpflowyOnboarding upflowyUrl={upflowyUrl} userData={userData} />}
    </GoogleReCaptchaProvider>
  );
};

export default FreeTrialOnboarding;
